import { Table, Input, Button, Divider, Row, Col, DatePicker } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import React from 'react';
import moment from 'moment';
import _ from 'lodash';

const { RangePicker } = DatePicker;

class TablaCasos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterDropdownVisible: false,
      verFiltroApellido: false,
      data: this.props.casos,
      textoBuscarNombre: '',
      textoBuscarApellido: '',
      textoBuscarDocumento: '',
      filtered: false,
    };
  }

  onInputChange = e => {
    this.setState({ textoBuscarNombre: e.target.value });
  };

  onApellidoChange = e => {
    this.setState({ textoBuscarApellido: e.target.value });
  };

  onDocumentoChange = e => {
    this.setState({ textoBuscarDocumento: e.target.value });
  };

  render() {
    const columns = [
      {
        title: 'Tipo Doc',
        dataIndex: ['victima', 'tipo_doc'],
        key: 'tipo_doc',
        align: 'center',
      },
      {
        title: 'Num Doc',
        dataIndex: ['victima', 'num_doc'],
        key: 'num_doc',
        align: 'center',
        filterDropdown: (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder="Buscar documento"
              value={this.state.textoBuscarDocumento}
              onChange={this.onDocumentoChange}
              onPressEnter={() =>
                this.props.filtrarPorDocumento(this.state.textoBuscarDocumento)
              }
            />
            <Button
              type="primary"
              onClick={() =>
                this.props.filtrarPorDocumento(this.state.textoBuscarDocumento)
              }
            >
              Buscar Documento
            </Button>
          </div>
        ),
        filterIcon: (
          <Icons.FilterOutlined
            style={{ color: this.state.filtered ? '#108ee9' : '#aaa' }}
          />
        ),
        filterDropdownVisible: this.state.verFiltroDocumento,
        onFilterDropdownVisibleChange: visible => {
          this.setState(
            {
              verFiltroDocumento: visible,
            },
            () => this.searchInput && this.searchInput.focus()
          );
        },
      },
      {
        title: 'Nombre',
        dataIndex: ['victima', 'nombre'],
        key: 'nombre',
        align: 'center',
        filterDropdown: (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder="Buscar nombre"
              value={this.state.textoBuscarNombre}
              onChange={this.onInputChange}
              onPressEnter={() =>
                this.props.filtrarPorNombre(this.state.textoBuscarNombre)
              }
            />
            <Button
              type="primary"
              onClick={() =>
                this.props.filtrarPorNombre(this.state.textoBuscarNombre)
              }
            >
              Buscar
            </Button>
          </div>
        ),
        filterIcon: (
          <Icons.FilterOutlined
            style={{ color: this.state.filtered ? '#108ee9' : '#aaa' }}
          />
        ),
        filterDropdownVisible: this.state.filterDropdownVisible,
        onFilterDropdownVisibleChange: visible => {
          this.setState(
            {
              filterDropdownVisible: visible,
            },
            () => this.searchInput && this.searchInput.focus()
          );
        },
      },
      {
        title: 'Apellido',
        dataIndex: ['victima', 'apellido'],
        key: 'apellido',
        align: 'center',
        filterDropdown: (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder="Buscar Apellido"
              value={this.state.textoBuscarApellido}
              onChange={this.onApellidoChange}
              onPressEnter={() =>
                this.props.filtrarPorApellido(this.state.textoBuscarApellido)
              }
            />
            <Button
              type="primary"
              onClick={() =>
                this.props.filtrarPorApellido(this.state.textoBuscarApellido)
              }
            >
              Buscar Apellido
            </Button>
          </div>
        ),
        filterIcon: (
          <Icons.FilterOutlined
            style={{ color: this.state.filtered ? '#108ee9' : '#aaa' }}
          />
        ),
        filterDropdownVisible: this.state.verFiltroApellido,
        onFilterDropdownVisibleChange: visible => {
          this.setState(
            {
              verFiltroApellido: visible,
            },
            () => this.searchInput && this.searchInput.focus()
          );
        },
      },
      {
        title: 'Fecha',
        dataIndex: 'fecha',
        key: 'fecha',
        align: 'center',
        render: fecha => moment(fecha).format('DD/MM/YYYY'),
      },
      {
        title: 'Nº',
        dataIndex: 'numero',
        key: 'numero',
        align: 'center',
        render: numero => (numero ? numero : '-'),
      },
      {
        title: 'N° Documentos',
        dataIndex: 'medidas',
        key: 'medidas',
        align: 'center',
        render: medidas => medidas.length,
      },
      {
        title: 'Acciones',
        key: 'acciones',
        align: 'center',
        render: (text, record) => (
          <span>
            {/* <Button
              type="primary"
              onClick={() =>
                this.props.history.push(
                  `/violenciaGenero/${record._id}/agregarMedida/`
                )
              }
            >
              Agregar Medida
            </Button> */}
            <Button
              type="primary"
              onClick={() =>
                this.props.history.push(`/violenciaGenero/caso/${record._id}/`)
              }
            >
              Ver
            </Button>
            <Divider type="vertical" />
            <Button
              type="danger"
              onClick={() => this.props.onDelete(record._id)}
            >
              Eliminar
            </Button>
          </span>
        ),
      },
    ];
    const { casos } = this.props;
    // console.log("CASOS: ", casos);
    // console.log("PROPS: ", this.props);

    const paginationOptions = {
      onChange: page => {
        this.props.cambiarPagina(page);
      },
      total: this.props.total,
      current: this.props.pagina,
      pageSize: this.props.tamPagina ? this.props.tamPagina : 10,
      pageSizeOptions: ['2', '5', '10', '20', '50'],
      showSizeChanger: true,
      showQuickJumper: true,
      onShowSizeChange: (current, pageSize) => {
        this.props.cambiarTamañoPagina(pageSize);
        this.props.cambiarPagina(1);
      },
    };

    return (
      <Table
        rowKey="_id"
        columns={columns}
        pagination={paginationOptions}
        dataSource={casos}
        bordered
        loading={this.props.loadingTabla}
        // expandedRowRender={record => {
        //   // console.log("Entre con: ", record);
        //   return _.map(record.medidas, medida => {
        //     return (
        //       <div key={medida._id}>
        //         <p style={{ margin: 0 }}>
        //           Documento generado el dia
        //           {moment(medida.fechaCreacion).format('DD/MM/YY')}
        //           <Button
        //             style={{ float: 'right', marginRight: 20 }}
        //             onClick={() =>
        //               this.props.history.push(`/documento/editar/${medida._id}`)
        //             }
        //           >
        //             Ver Documento
        //           </Button>
        //         </p>
        //         <Divider />
        //       </div>
        //     );
        //   });
        // }}
        title={() => (
          <div>
            <h2 style={{ textAlign: 'center' }}>
              Casos de Violencia de Genero
            </h2>
            <div style={{ textAlign: 'center' }}>
              <Row style={{ marginTop: 10 }}>
                <Col>
                  <h3>FECHAS:</h3>
                </Col>

                <Col span={6}>Cantidad Total de Casos: {this.props.total}</Col>
                <Col span={12}>
                  <RangePicker
                    style={{ width: 500, marginLeft: 10 }}
                    onChange={this.props.onChange}
                    defaultValue={
                      this.props.fechaInicial && this.props.fechaFinal
                        ? [
                            moment(this.props.fechaInicial),
                            moment(this.props.fechaFinal),
                          ]
                        : [moment().subtract(7, 'd'), moment()]
                    }
                    format={'DD-MM-YYYY'}
                  />
                </Col>
              </Row>
            </div>
          </div>
        )}
        locale={{
          emptyText: 'Sin casos de violencia de genero.',
        }}
      />
    );
  }
}

export default TablaCasos;
